<script>
    import _ from 'lodash'
    import moment from 'moment'
    import RecordCourseService from '@/request/record/recordCourse'
    import RecordImageList from './image-list'
    export default {
        name: 'RecordCourseEdit',
        components: {
            RecordImageList
        },
        props: {
            value: {
                type: Object,
                default () {
                    return {}
                }
            },
            mark: {
                type: String,
                default: '医步'
            },
            showButtons: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                course: {},
                tagSelection: [],
                tagLoading: false,
                enableAdd: false,
                saving: false
            }
        },
        created () {
            this.course = _.cloneDeep(this.value)
            if (!this.course.time) {
                this.$set(this.course, 'time', moment().startOf('day').valueOf())
            }
        },
        computed: {},
        mounted () {},
        watch: {
            value (val) {
                this.course = _.cloneDeep(val)
                if (!this.course.time) {
                    this.$set(this.course, 'time', moment().startOf('day').valueOf())
                }
            }
        },
        methods: {
            listTag () {
                RecordCourseService.findTag({
                    pageOffset: 1,
                    pageSize: 100
                }).then(res => {
                    let data = res.result['content'] || []
                    this.tagSelection = _.clone(data)
                }).finally(() => {
                    this.tagLoading = false
                })
            },
            handleCancle () {
                this.$emit('cancle')
            },
            save () {
                this.saving = true
                if (!this.course.tag || this.course.tag === '') {
                    this.$message.error('标签不能为空！')
                    this.saving = false
                    return
                }
                let cou = _.cloneDeep(this.course)
                if (_.isEqual(cou, this.value)) {
                    this.saving = false
                    this.$emit('saveDone', this.value)
                    return
                }
                RecordCourseService.save(cou).then(res => {
                    let data = res.result || {}
                    if (_.isEmpty(data)) {
                        this.saving = false
                        this.$emit('saveDone', data)
                        return
                    }
                    this.$emit('input', data)
                    if (cou.id) {
                        this.saving = false
                        this.$emit('saveDone', this.course)
                    }
                })
            },
            handleSaveImagesDone () {
                if (this.saving) {
                    this.saving = false
                    this.$emit('saveDone', this.course)
                }
            },
            handleSaveImagesFail (error) {
                if (this.saving) {
                    this.saving = false
                    this.$message.error(error || '保存图片失败')
                }
            },
            handleRemoveImage () {}
        }
    }
</script>

<template>
    <el-form ref="form" :model="course" :disabled="saving" @keyup.enter.native="save" label-position="right" label-width="80px">
        <el-form-item label="标签">
            <el-select
                    v-model="course.tag"
                    filterable
                    remote
                    allow-create
                    default-first-option
                    placeholder="输入关键词查找(支持新建)"
                    :remote-method="listTag"
                    :loading="tagLoading"
                    @focus="listTag()"
                    style="width: 100%;">
                <el-option
                        v-for="item in tagSelection"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="日期">
            <el-date-picker
                    v-model="course.time"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy年MM月dd日"
                    value-format="timestamp"
                    style="width: 100%;"
                    :clearable="false"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="描述">
            <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="course.remark" placeholder="请输入描述"></el-input>
        </el-form-item>
        <record-image-list
                ref="imageList"
                :source-id="course.id"
                source="course"
                :mark="mark"
                :enable-add="true"
                :disabled="false"
                @remove="handleRemoveImage"
                @saveImagesDone="handleSaveImagesDone"
                @saveImagesFail="handleSaveImagesFail"
        ></record-image-list>
        <el-form-item v-if="showButtons">
            <el-button type="primary" @click="save" :disabled="true">确定</el-button>
            <el-button @click="handleCancle">取消</el-button>
        </el-form-item>
    </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
